import PreviewWindow from "./PreviewWindow";

export default class PreviewWindowContainer {
	constructor(objectManager, eyedropperPopup, colorManager, buttons, download, autoFocus) {
		this._objectManager = objectManager;
		this._eyedropperPopup = eyedropperPopup;
		this._colorManager = colorManager;
		this._buttons = buttons;
		this._download = download;
		this._autoFocus = autoFocus;
		this._elContainer = document.getElementById('windowContainer');
		this._previewWindows = [];
	}
	addWindow(objectIdx) {
		const imageDataManager = this._objectManager.getImageDataManager(objectIdx);
		const previewWindow = new PreviewWindow(imageDataManager, this._eyedropperPopup, this._colorManager, this._buttons, this._download, this._autoFocus, this._elContainer, (self) => {
			this._previewWindows = this._previewWindows.filter((previewWindow) => previewWindow !== self);
		});
		this._previewWindows.push(previewWindow);
	}
	update() {
		for(const previewWindow of this._previewWindows) {
			previewWindow.updateIf(this._objectManager.getCurrentImageDataManager());
		}
	}
	clear() {
		while(this._previewWindows.length > 0) {
			this._previewWindows[0].delete();
		}
	}
}
